<template>
<div id="bulk-copy-dialog" class="ui modal">
  <i class="close icon"></i>
  <div class="header">対象店舗選択</div>
  <div class="scrolling content">
    <form class="ui form">
      <table class="ui selectable striped table">
        <thead>
          <tr>
            <th colspan="2">
              <input v-model="groupShopNameFilter" type="text" placeholder="店舗名で絞り込む">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="shop in filteredGroupShops" :key="shop.id" @click="toggle(shop)" class="clickable">
            <td><i v-if="isSelectedShop(shop)" class="green large check circle outline icon"></i></td>
            <td>{{ shop.name }}</td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
  <div class="actions">
    <div class="ui cancel button">閉じる</div>
    <div class="ui green button" :class="{loading: form.waiting, disabled: filteredSelectedGroupShops().length === 0}" @click="bulkCopy">{{ filteredSelectedGroupShops().length }}件に反映する</div>
  </div>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm(),
            groupShops: [],
            groupShopNameFilter: null,
            selectedGroupShops: [],
            bulkActionApiUrl: null,
        };
    },
    computed: {
        filteredGroupShops: function() {
            return _.filter(this.groupShops, function(shop) {
                if (!this.groupShopNameFilter) {
                    return true;
                }
                return _.includes(shop.name, this.groupShopNameFilter);
            }.bind(this));
        }
    },
    methods: {
        open: function(bulkActionApiUrl, groupShops) {
            this.bulkActionApiUrl = bulkActionApiUrl;
            this.groupShops = groupShops;
            this.selectedGroupShops = _.map(this.groupShops, 'id');
            $('#bulk-copy-dialog').modal('show');
        },
        isSelectedShop: function(shop) {
            return _.includes(this.selectedGroupShops, shop.id);
        },
        filteredSelectedGroupShops: function() {
            return _.chain(this.filteredGroupShops).filter(function(shop) {
                return _.includes(this.selectedGroupShops, shop.id);
            }.bind(this)).map('id').value();
        },
        toggle: function(shop) {
            if (_.includes(this.selectedGroupShops, shop.id)) {
                var index = this.selectedGroupShops.indexOf(shop.id);
                this.selectedGroupShops.splice(index, 1);
            } else {
                this.selectedGroupShops.push(shop.id);
            }
        },
        bulkCopy: function() {
            this.form.model.shops = this.filteredSelectedGroupShops();
            this.form.put(this.bulkActionApiUrl, function() {
                alert('完了しました');
                $('#bulk-copy-dialog').modal('hide');
            });
        }
    }
};
</script>
